const legal = [
  {
    id: 'musicSubmissionPolicy',
    href: 'https://audacyinc.com/music-submission-policy?_ga=2.233015198.1281480628.1648568981-1360993713.1648568980',
    label: 'Music submission policy',
    openInNewTab: true,
  },
  {
    id: 'privacyPolicy',
    href: 'https://audacyinc.com/privacy-policy?_ga=2.169427105.1281480628.1648568981-1360993713.1648568980',
    label: 'Privacy policy',
    openInNewTab: true,
  },
  {
    id: 'termsOfUse',
    href: 'https://audacyinc.com/terms-and-conditions?_ga=2.127969292.1281480628.1648568981-1360993713.1648568980',
    label: 'Terms of use',
    openInNewTab: true,
  },
  {
    id: 'copyrightNotice',
    href: 'https://audacyinc.com/copyright-notice/?_ga=2.127969292.1281480628.1648568981-1360993713.1648568980',
    label: 'Copyright notice',
    openInNewTab: true,
  },
];

const downloadApp = [
  {
    id: 'appleStore',
    href: 'https://go.audacy.com/download-apple',
    label: 'Download on the App Store',
  },
  {
    id: 'googlePlay',
    href: 'https://go.audacy.com/download-android',
    label: 'Get it on Google Play',
  },
];

const social = [
  {
    id: 'twitter',
    href: 'https://twitter.com/audacy',
    label: 'Twitter',
  },
  {
    id: 'facebook',
    href: 'https://www.facebook.com/audacyapp/',
    label: 'Facebook',
  },
  {
    id: 'youTube',
    href: 'https://www.youtube.com/AudacyOriginals',
    label: 'YouTube',
  },
  {
    id: 'instagram',
    href: 'https://www.instagram.com/audacy/',
    label: 'Instagram',
  },
];

const forListeners = {
  title: {
    id: 'forListeners',
    label: 'For listeners',
  },
  links: [
    {
      id: 'audacyLive',
      href: 'https://www.audacy.com/live',
      label: 'Audacy Live',
      openInNewTab: true,
    },
    {
      id: 'events',
      href: 'https://www.audacy.com/events',
      label: 'Events',
      openInNewTab: true,
    },
    {
      id: 'contests',
      href: 'https://www.audacy.com/contests',
      label: 'Contests',
      openInNewTab: true,
    },
    {
      id: 'customerSupport',
      href: 'https://support.audacy.com/hc/en-us',
      label: 'Customer support',
      openInNewTab: true,
    },
    {
      id: 'signUpForEmail',
      href: 'https://www.audacy.com/newsletter/subscribe',
      label: 'Sign up for email',
      openInNewTab: true,
    },
    {
      id: 'shopAudacy',
      href: 'https://shop.audacy.com/?utm_medium=nav-bar&utm_source=audacy.com',
      label: 'Shop Audacy',
      openInNewTab: true,
    },
    {
      id: 'getMyPerks',
      href: 'http://www.getmyperks.com/?_ga=2.61948972.1281480628.1648568981-1360993713.1648568980',
      label: 'Get my PERKS',
      openInNewTab: true,
    },
    {
      id: 'doNotSellMyPersonalInfo',
      href: 'none',
      label: 'Do not sell or share my personal info',
      useClickHandler: true,
      onClick: (): void => {}, // replaced inline since it depends on component state
    },
    {
      id: 'sitemap',
      href: 'https://www.audacy.com/sitemap',
      label: 'Sitemap',
      openInNewTab: true,
    },
  ],
};

const forAffiliates = {
  title: {
    id: 'forListeners',
    label: 'For affiliates',
  },
  links: [
    {
      id: 'submitAPodcast',
      href: 'https://www.listennotes.com/submit/',
      label: 'Submit a podcast',
      openInNewTab: true,
    },
  ],
};

const ourCompany = {
  title: {
    id: 'ourCompany',
    label: 'Our company',
  },
  links: [
    {
      id: 'aboutAudacy',
      href: 'https://www.audacy.com/about',
      label: 'About Audacy',
      openInNewTab: true,
    },
    {
      id: 'careers',
      href: 'https://audacyinc.com/careers?_ga=2.136471728.1281480628.1648568981-1360993713.1648568980',
      label: 'Careers',
      openInNewTab: true,
    },
    {
      id: 'advertiseWithUs',
      href: 'https://audacyinc.com/capabilities?_ga=2.132752398.1281480628.1648568981-1360993713.1648568980',
      label: 'Advertise with us',
      openInNewTab: true,
    },
    {
      id: '1thing',
      href: 'https://www.audacy.com/1thing',
      label: '1Thing',
      openInNewTab: true,
    },
    {
      id: 'corporateSite',
      href: 'http://audacyinc.com/?_ga=2.232940446.1281480628.1648568981-1360993713.1648568980',
      label: 'Corporate site',
      openInNewTab: true,
    },
  ],
};

export default {
  downloadApp,
  legal,
  main: [forListeners, forAffiliates, ourCompany],
  social,
};
